export default __webpack_public_path__ + "faef548fb51aff772349268843df8523.png";